// ============================================================
// THEME — single source of truth for colors, branding, and vibe
// ============================================================
// To rebrand for a new shop/cabin, only change values below.
// Also update (3 spots total):
//   1. this file (src/theme.js)
//   2. public/manifest.json  -> theme_color + name + short_name
//   3. public/index.html     -> <meta name="theme-color">, <title>, <meta name="description">
// ============================================================

const theme = {
  // Brand identity
  name: 'Poke Pine Cabin',
  tagline: 'Family-owned Pokemon shop in the Crestline mountains',

  // Primary brand color — used for buttons, links, active states
  primary: '#C8102E',       // red
  primaryDark: '#9d0c24',   // darker hover/press state
  primaryLight: '#e8334e',  // lighter accent
  primaryBg: '#fff0f0',     // very light tint (backgrounds, alerts)
  primaryBorder: '#fecaca', // light tinted border (pairs with primaryBg)

  // Neutrals
  textDark: '#1a1a1a',
  textMedium: '#444',
  textMuted: '#666',
  textLight: '#999',
  textFaint: '#aaa',

  // Surfaces
  white: '#fff',
  surfaceBg: '#fafafa',
  surfaceAlt: '#f8f8f8',
  surfaceMuted: '#f0f0f0',
  border: '#eee',
  borderSoft: '#f5f5f5',

  // Category colors (semantic, kept stable across themes)
  categories: {
    trade_night: '#C8102E',  // follows brand
    tournament:  '#2563eb',  // blue
    big_event:   '#7c3aed',  // purple
    other:       '#ea580c',  // orange
  },

  // Misc
  overlay: 'rgba(0,0,0,0.5)',
};

export default theme;
